<template>
  <div :id="id" class="bg-white px-2 py-1 rounded-lg">
    <div class="text-sm text-grey-200">
      {{ init ? "Initié par" : "Vu par" }}
    </div>
    <div class="flex items-center">
      <PTooltip
        activatorWrapperClasses="w-full whitespace-nowrap overflow-hidden text-ellipsis"
        class="grow w-0 [&_.bg-grey-425]:max-w-[90%]"
        :label="`${element.mail} - ${element.name}`"
        :delay="500"
        :offset="5"
      >
        <p class="font-bold inline">{{ element.name }}</p>
      </PTooltip>

      <PTooltip
        v-if="isCurrent && !letterFileStore.balaWhiteList.includes(element.mail)"
        :label="`Inviter ${element.name} à revoir le parapheur`"
        :delay="500"
        :offset="5"
      >
        <PButton
          @click="seeAgainUpstream(lfId, element)"
          :data-sentry-id="`SeeAgainBtn-${element.id}`"
          :aria-label="`Inviter ${element.name} à revoir le parapheur`"
          size="icon"
          mode="tertiary-borderless"
        >
          <OhVueIcon :name="bellIcon" class="text-blue-france-sun-113" />
        </PButton>
      </PTooltip>

      <PTooltip
        class="mr-1v"
        v-if="isCurrent && !letterFileStore.balaWhiteList.includes(element.mail)"
        :label="`Ajouter ${element.name} en bas du flux`"
        :delay="500"
        :offset="5"
      >
        <PButton
          :data-sentry-id="`AddEndStreamBtn-${element.id}`"
          size="icon"
          mode="tertiary-borderless"
          :aria-label="`Ajouter ${element.name} en bas du flux`"
          @click="emit('addToEndStream')"
        >
          <OhVueIcon :name="addUserIcon" class="text-success" />
        </PButton>
      </PTooltip>

      <span class="text-grey-425 ml-auto">{{ formatDate(element.creationDate || "") }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { seeAgainUpstream } from "@/app/utils/see-again.ts";
import { PButton, PTooltip, useIcons } from "@pasta/box-v2";
import dayjs from "dayjs";
import { OhVueIcon } from "oh-vue-icons";
import { OiBell, RiUserAddFill } from "oh-vue-icons/icons";
import { useId } from "vue";
import { type FluxElementDto } from "../../../dto/flux-element.dto";
import { useLetterFileStore } from "../../../stores/letter-file.store";

interface Props {
  element: FluxElementDto;
  lfId: number;
  isCurrent: boolean;
  init?: boolean;
}
defineProps<Props>();
const emit = defineEmits<{
  (e: "addToEndStream"): void;
}>();

const id = useId();
const [bellIcon, addUserIcon] = useIcons(OiBell, RiUserAddFill);
const letterFileStore = useLetterFileStore();

function formatDate(date: string) {
  return dayjs(date).format("DD/MM/YYYY");
}
</script>
